(function (angular) {
    angular.module('bizPartEngage').controller('core.welcome', welcomeController);

    welcomeController.$inject = ["$rootScope", "bizCoreService"];

    function welcomeController($rootScope, bizCoreService) {
        var vm = this;        

        vm.Init = Init;
        vm.Back = Back;

        function Back() {
            window.history.back();
        }

        function Init() {
            bizCoreService.GetWelcomeGuide().then(function (response) {
                var showAdvanced = true;//backwards compatibility, if setting is missing
                var pages;
                if (response.data && response.data !== "" && response.data !== null) {
                    const data = JSON.parse(response.data);
                    showAdvanced = data.useAdvanced;
                    pages = data.pages;                    
                }
                vm.showAdvanced = showAdvanced;
                vm.pages = pages;
            });            
        }

        $rootScope.Initialized.then(vm.Init);
    }
}(window.angular));